import { Button, Col, DatePicker, Form, Input, InputNumber, Modal, Row, Select } from "antd";
import { Menu } from "../../../model/menudesign/Menu";
import { PostMenus } from "../../../dao/menudesign/PostMenus";
import { BiCheck, BiX } from "react-icons/bi";
import {BsEye, BsPlusCircle, BsReceiptCutoff} from "react-icons/bs";
import { GetMenus } from "../../../dao/menudesign/GetMenus";
import { useEffect, useState } from "react";
import Colors from "../../../styles/Colors";
import { GetPlats } from "../../../dao/menudesign/GetPlats";
import { Plat } from "../../../model/menudesign/Plat";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import isLeapYear from 'dayjs/plugin/isLeapYear';
import dayjs, { Dayjs } from "dayjs";
import Variacio from "../../../model/menudesign/Variacio";
import { GetVariacio } from "../../../dao/menudesign/GetVariacio";
import PlatModal from "./PlatModal";
import toast, {Toaster} from "react-hot-toast";
import isoWeek from "dayjs/plugin/isoWeek";
dayjs.extend(isoWeek);


interface MenuModalProps {
    element: Menu;
    visible: boolean;
    page: string;
    editar?: boolean;
    setmana: string;
    onClose: (value: boolean) => void;
    dataM: string; 
    idBasal?: number | null; 
}

const MenuModal: React.FC<MenuModalProps> = ({element, visible, page, editar, setmana, onClose, dataM, idBasal}) => {
    const [form] = Form.useForm();
    const [variants, setVariants] = useState<{ value: number; label: string; }[]>([]);
    const [plats, setPlats] = useState<{ value: number; label: string; }[]>([]);
    const posicions = [{value:0, label:"Complement"},{value: 1, label: 'Primer plat'},{value: 2, label: 'Segon plat'},{value: 3, label: 'Postre'}];
    const dies = [{value:0, label:"Dilluns"},{value:1, label:"Dimarts"},{value:2, label:"Dimecres"},{value:3, label:"Dijous"},{value:4, label:"Divendres"}];
    const [primerPlats, set1Plats] = useState<{ value: number; label: string; }[]>([]);
    const [segonPlats, set2Plats] = useState<{ value: number; label: string; }[]>([]);
    const [postrePlats, setPostrePlats] = useState<{ value: number; label: string; }[]>([]);
    const [complementPlats, setCompPlats] = useState<{ value: number; label: string; }[]>([]);
    const [nouElementP, setNouElementP] = useState(false);
    const [elementSelectedP, setElementSelectedP] = useState<Plat>(new Plat());

    async function checkListas(){
        const dades = await GetMenus(page) || [];
        const plats = await GetPlats(page) || [];
        const variants = await GetVariacio(page);
        const varList = variants.map((element: Variacio) => ({
            value: element.id,
            label: element.nom,
        }));
        const platList = plats.map((element: Plat) => ({
            value: element.id,
            label: element.nom,
        }));
        setPlats(platList);
        setVariants(varList);
        const primers = plats.filter(p => p.tipus == "Primer plat");
        const segons = plats.filter(p => p.tipus == "Segon plat");
        const postres = plats.filter(p => p.tipus == "Postre");
        const complements = plats.filter(p => p.tipus == "Complement");
        const primerList = primers.map((element: Plat) => ({
            value: element.id,
            label: element.nom,
        }));
        const segonList = segons.map((element: Plat) => ({
            value: element.id,
            label: element.nom,
        }));
        const postreList = postres.map((element: Plat) => ({
            value: element.id,
            label: element.nom,
        }));
        const complementList = complements.map((element: Plat) => ({
            value: element.id,
            label: element.nom,
        }));
        set1Plats(primerList);
        set2Plats(segonList);
        setPostrePlats(postreList);
        setCompPlats(complementList);
    }

    async function handleSubmit() {
        const formData = form.getFieldsValue();

        // Calcular fecha y semana desde dataM
        const fecha = dayjs(dataM);
        formData.data = fecha.format("YYYY-MM-DD");
        formData.dia = fecha.isoWeekday() - 1;
        formData.setmana = setmana;

        const menuplat = [
        { id_plat: formData.id_plat_1, dia: formData.dia, posicio: 0, data: formData.data },
        { id_plat: formData.id_plat_2, dia: formData.dia, posicio: 1, data: formData.data },
        { id_plat: formData.id_plat_3, dia: formData.dia, posicio: 2, data: formData.data },
        { id_plat: formData.id_plat_4, dia: formData.dia, posicio: 3, data: formData.data },
        ].filter(item => item.id_plat !== undefined && item.id_plat !== null);

        delete formData.id_plat_1;
        delete formData.id_plat_2;
        delete formData.id_plat_3;
        delete formData.id_plat_4;

        formData.menu_plat = JSON.stringify(menuplat);

        await PostMenus(formData, page);
        await onClose(true);
    }



    async function handleCancel() {
        await onClose(false);
    };

    async function handleCloseModalP(value: boolean) {
        if (value)
            toast.success("GUARDAT");
        else
            toast.error("NO GUARDAT");
        setNouElementP(false);
        checkListas();
    }

    function afegirElementP(element: Plat) {
        setNouElementP(!nouElementP);
        setElementSelectedP(element);
    }

    useEffect(() => {
        checkListas();
    }, []);
    
    return (
        <Modal
        title="Crear/Editar Menu"
            open={visible}
            onCancel={handleCancel}
            footer={[
                <>
                    <Button title={"Acceptar"} style={{backgroundColor: Colors.colors.color6}}
                            onClick={handleSubmit}><BiCheck/></Button>
                    {" "}
                    <Button title={"Cancelar"} style={{backgroundColor: Colors.colors.color1}}
                            onClick={handleCancel}><BiX/></Button>
                </>
            ]}
            width={1000}
        >
            <Toaster/>
            <Form form={form} initialValues={{
    ...element,
    basal: idBasal ? idBasal : element.basal, // 👈 si hay basal, usar ese id
  }}>
                <br/>
                <Row gutter={[16, 16]}>
                    <Col span={24}>
                        <Form.Item label="ID" name="id">
                            <Input type="text" disabled={true}/>
                        </Form.Item>
                        <Form.Item label="Variant" name="id_variacio"
                            rules={[{required: true, message: 'Aquest camp es obligatori'}]}>
                            <Select
                                showSearch
                                optionFilterProp="label"
                                options={idBasal ? variants.filter(v => v.value !== 0) : variants}

                            />
                        </Form.Item>
                        <Form.Item label="Menu Basal" name="basal" hidden >
                            <Input type="number" disabled={!!idBasal} 
                               />
                        </Form.Item>
                    </Col>
                </Row>
                <hr/>
                    <Row>
                        <h6>Plats 
                            <Button title={"Crear nou plat"} style={{border:'0px'}} onClick={() => afegirElementP(new Plat())}>
                                <BsPlusCircle color={Colors.colors.color2 }/>
                            </Button>  
                        </h6>
                       
                    </Row>
                <br/>
                <Row gutter={8}>
                    <Col span={12}>
                        <Form.Item label="Primer Plat" name="id_plat_1" key="id_plat_1"
                            rules={[{required: true, message: 'Aquest camp es obligatori'}]}>
                            <Select
                                showSearch
                                optionFilterProp="label"
                                options={primerPlats}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item label="Segon Plat" name="id_plat_2" key="id_plat_2" 
                            rules={[{required: true, message: 'Aquest camp es obligatori'}]}>
                            <Select
                                showSearch
                                optionFilterProp="label"
                                options={segonPlats}
                            />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={8}>
                    <Col span={12}>
                        <Form.Item label="Complement" name="id_plat_3" key="id_plat_3"
                           >
                            <Select
                                showSearch
                                optionFilterProp="label"
                                options={complementPlats}
                            />
                        </Form.Item>
                    </Col>
                   <Col span={12}>
                        <Form.Item label="Postre" name="id_plat_4" key="id_plat_4"
                            rules={[{required: true, message: 'Aquest camp es obligatori'}]}>
                            <Select
                                showSearch
                                optionFilterProp="label"
                                options={postrePlats}
                            />
                        </Form.Item>
                    </Col>
                </Row>
                
            </Form>
            {nouElementP && (
                        <PlatModal
                        element={elementSelectedP}
                        onClose={handleCloseModalP}
                        visible={nouElementP}
                        editar={true}
                        page={page}
                        />
                    )}
        </Modal>
    )
};
export default MenuModal;